import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { showTwoFactorAuthenticationPopupAction } from '../store/actions';

export const useTwoFactorAuthenticationPopup = () => {
    const dispatch = useDispatch();

    return useCallback(
        popupData => dispatch(showTwoFactorAuthenticationPopupAction(popupData)),
        [dispatch]
    );
};
